import { DataFlag } from '@naturalcycles/shared'

export const pmpSymptomCategories: PerimenopauseAssessmentSymptomGroup = {
  physicalSymptoms: [
    DataFlag.PAIN_HOT_FLASHES,
    DataFlag.PAIN_NIGHT_SWEATS,
    DataFlag.PAIN_HEART_PALPITATIONS,
    DataFlag.PAIN_JOINT,
    DataFlag.PAIN_SORE_BREASTS,
    DataFlag.WEIGHT_GAIN,
  ],
  sleepSymptoms: [DataFlag.PAIN_FATIGUE, DataFlag.PAIN_INSOMNIA],
  moodSymptoms: [
    DataFlag.PAIN_BRAIN_FOG,
    DataFlag.MOOD_IRRITABLE,
    DataFlag.MOOD_FEELING_LOW,
    DataFlag.MOOD_ANXIOUS,
  ],
  urinarySymptoms: [
    DataFlag.PAIN_FREQUENT_URINATION,
    DataFlag.PAIN_BLADDER_LEAKAGE,
    DataFlag.PAIN_VAGINAL_DRYNESS,
    DataFlag.LOWER_LIBIDO,
  ],
  lifestyleSymptoms: [
    DataFlag.LIFESTYLE_STRESS,
    DataFlag.LIFESTYLE_ALCOHOL,
    DataFlag.LIFESTYLE_SMOKING,
    DataFlag.LIFESTYLE_CAFFEINE,
    DataFlag.LIFESTYLE_SUGAR,
    DataFlag.LIFESTYLE_HIGH_FAT_FOOD,
  ],
  selfcareSymptoms: [
    DataFlag.LIFESTYLE_THERAPY,
    DataFlag.LIFESTYLE_MINDFULNESS,
    DataFlag.LIFESTYLE_BREATHING_EXERCISE,
    DataFlag.LIFESTYLE_JOURNALING,
    DataFlag.LIFESTYLE_KEGEL_EXERCISE,
    DataFlag.LIFESTYLE_SUPPLEMENTS,
  ],
}

interface PerimenopauseAssessmentSymptomGroup {
  physicalSymptoms: DataFlag[]
  sleepSymptoms: DataFlag[]
  moodSymptoms: DataFlag[]
  urinarySymptoms: DataFlag[]
  lifestyleSymptoms: DataFlag[]
  selfcareSymptoms: DataFlag[]
}

export const TEMP_PMP_IMG = 'https://placehold.co/'
